import {
  FETCH_CONFIGURATOR_PAGE_NECKLACE_FIELDS,
  TOGGLE_NECKLACE_MODAL,
  TOGGLE_MEMORY_MODAL,
  CLOSE_NECKLACE_MODALS,
  SELECT_ACTIVE_MEMORY_IN_MODAL,
  TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL,
  UPDATE_ACTIVE_MEMORY_ENGRAVING,
  RESET_ACTIVE_EDIT_MEMORY,
  TOGGLE_MEMORY_MODAL_WITH_MEMORY,
} from "../actions/types";

const INITIAL_STATE = {
  pageTitleText: "",
  selectNecklaceButtonText: "",
  selectMemoryButtonText: "",
  editButtonText: "",
  selectedItemsText: "",
  priceText: "",
  backButtonText: "",
  forwardButtonText: "",
  necklaceOverlayTitleText: "",
  necklaceOverlayNoPriceCalcText: "",
  memoryOverlayTitleText: "",
  memoryOverlayCollectionTitleText: "",
  modalNecklaceOpen: false,
  modalMemoryOpen: false,
  modalMemoryIndex: 0,
  modalShowEditMemory: false,
  modalActiveMemory: null,
  modalActiveMemoryEngraving: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONFIGURATOR_PAGE_NECKLACE_FIELDS:
      return {
        ...state,
        pageTitleText: action.payload.items[0].fields.pageTitleText,
        selectNecklaceButtonText:
          action.payload.items[0].fields.selectNecklaceButtonText,
        selectMemoryButtonText:
          action.payload.items[0].fields.selectMemoryButtonText,
        editButtonText: action.payload.items[0].fields.editButtonTitleText,
        selectedItemsText:
          action.payload.items[0].fields.selectedItemsTitleText,
        priceText: action.payload.items[0].fields.priceText,
        backButtonText: action.payload.items[0].fields.backButtonText,
        forwardButtonText: action.payload.items[0].fields.forwardButtonText,
        necklaceOverlayTitleText:
          action.payload.items[0].fields.necklaceOverlayTitleText,
        necklaceOverlayNoPriceCalcText:
          action.payload.items[0].fields.necklaceOverlayNoPriceCalculationText,
        memoryOverlayTitleText:
          action.payload.items[0].fields.memoryOverlayTitleText,
        memoryOverlayCollectionTitleText:
          action.payload.items[0].fields.memoryOverlayCollectionTitleText,
      };
    case TOGGLE_NECKLACE_MODAL:
      return {
        ...state,
        modalNecklaceOpen: !state.modalNecklaceOpen,
        modalMemoryOpen: false,
      };
    case TOGGLE_MEMORY_MODAL:
      return {
        ...state,
        modalMemoryOpen: !state.modalMemoryOpen,
        modalMemoryIndex: action.payload,
        modalNecklaceOpen: false,
      };
    case TOGGLE_MEMORY_MODAL_WITH_MEMORY:
      return {
        ...state,
        modalMemoryOpen: true,
        modalMemoryIndex: action.index,
        modalActiveMemory: action.memory,
        modalActiveMemoryEngraving: action.engraving,
      };
    case CLOSE_NECKLACE_MODALS:
      return {
        ...state,
        modalNecklaceOpen: false,
        modalMemoryOpen: false,
      };
    case SELECT_ACTIVE_MEMORY_IN_MODAL:
      return {
        ...state,
        modalActiveMemory: action.payload,
      };
    case TOGGLE_SHOW_EDIT_MEMORY_IN_MODAL:
      return {
        ...state,
        modalShowEditMemory: action.payload,
      };
    case UPDATE_ACTIVE_MEMORY_ENGRAVING:
      return {
        ...state,
        modalActiveMemoryEngraving: action.payload,
      };
    case RESET_ACTIVE_EDIT_MEMORY:
      return {
        ...state,
        modalActiveMemoryEngraving: "",
        modalShowEditMemory: false,
        modalActiveMemory: null,
        modalMemoryIndex: 0,
        modalNecklaceOpen: false,
        modalMemoryOpen: false,
      };
    default:
      return state;
  }
};
